

export interface IScopeRoleData {
    group: string;
    active: boolean;
    id: string;
    name: string;
    displayName: string;
}

export default class scopeRoleData implements IScopeRoleData {
    group: string;
    active: boolean;
    id: string;
    name: string;
    displayName: string;
    constructor(
        group: string,
        active: boolean,
        id: string,
        name: string,
        displayName: string,
    ) {
        this.group = group;
        this.active = active;
        this.id = id;
        this.name = name;
        this.displayName = displayName;
    }
}

const defaultScopeRoleData = new scopeRoleData("", false, "", "", "");
export { defaultScopeRoleData };